// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_2N-zMXXwD8OzWfPa1PycVE","testContainer":"_3_dkS2ueeemZ8LRPEtxGDJ","headerTitle":"_2uriXc5iEa8PHnk94SstNG","testTitle":"_3u0MzQW6sG5RayN0BxClXC","testBody":"WJHU0m8bzPPPtCe1nflNA","testCopy":"_2Pmi37IHuKyeoJbYUpG528","testButton":"_2H9jvp45S-txK9ljnfiN5_","retakeButton":"GaW-plxsQkPGFrsMnkPcf","answerButton":"_1S5-Gm0xyMrQAv1Hcn12m2","copy":"_1tErasd-cLyCfkNMbVw5kg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/Tests.css
// module id = 499
// module chunks = 0